import React from "react"

const encode = ({ scope, country = "", region = "", city = "" }) => (
  [scope, country, region, city].join("|")
)

const selectedValue = query => encode({
  scope: query.locationScope,
  country: query.country,
  region: query.region,
  city: query.city,
})

const ActivityLocationControl = ({ query, catalog, onChange }) => {
  const countries = catalog?.countries || [{ key: "Romania", label: "Romania" }]
  const regions = (catalog?.operationalRegions || []).filter(({ key }) => key !== "Unmapped")
  const cities = catalog?.cities || []
  const options = [
    { scope: "global", label: "Global · all locations" },
    ...countries.map(country => ({
      scope: "country", country: country.key, label: `Country · ${country.label}`,
    })),
    ...regions.map(region => ({
      scope: "region", country: region.country, region: region.key, label: `Region · ${region.label}`,
    })),
    ...cities.map(city => ({
      scope: "city", country: city.country, region: city.region, city: city.key,
      label: `City · ${city.label} · ${city.region}`,
    })),
    ...countries.map(country => ({
      scope: "unmapped", country: country.key, label: `Unmapped · ${country.label}`,
    })),
  ]

  const apply = value => {
    const option = options.find(candidate => encode(candidate) === value) || options[0]
    onChange({
      locationScope: option.scope,
      country: option.country,
      region: option.region,
      city: option.city,
    })
  }

  return (
    <label className="analytics-location-control">
      <span>Activity location scope</span>
      <select aria-label="Activity location scope" value={selectedValue(query)} onChange={event => apply(event.target.value)}>
        {options.map(option => (
          <option value={encode(option)} key={encode(option)}>{option.label}</option>
        ))}
      </select>
      <small>Country → Operational Region → City is one path · taxonomy {catalog?.mappingVersion || "newsletter-export-v1"}</small>
    </label>
  )
}

export default ActivityLocationControl
